/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import React from "react";
import { When } from "react-if";
import { Checkbox, Row, Table, Text, theme } from "@nordcloud/gnui";
import { AppEnvRow } from "./AppEnvRow";
import { StyledTd, TdWithMinWidth } from "./styles";
import { AppEnvTableProps, SELECTOR_TYPE } from "./types";

export function AppEnvTable({
  filteredApps,
  selectedEnvs,
  setSelectedEnvs,
  selectedApps,
  setSelectedApps,
  selectionType,
  disabled = false,
}: AppEnvTableProps) {
  const [allSelected, setAllSelected] = React.useState(false);

  React.useEffect(() => {
    selectAll();
  }, [allSelected]);

  const selectAll = () => {
    if (allSelected) {
      setSelectedApps(
        filteredApps.map((app) => ({
          nid: app?.nid,
          name: app?.name,
        }))
      );
    } else {
      setSelectedApps([]);
    }
  };

  return (
    <Table small>
      <When condition={selectionType === SELECTOR_TYPE.checkbox}>
        <Table.tbody>
          <Table.tr>
            <TdWithMinWidth />
            <StyledTd>
              <Checkbox
                data-testid="application-select"
                checked={allSelected}
                onChange={() => {
                  setAllSelected((prevState) => !prevState);
                }}
              />
            </StyledTd>
            <Table.td
              css={{
                wordBreak: "break-all",
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              <Row css={{ marginLeft: 0 }}>
                <Text tag="span" size="sm" color={theme.color.text.text02}>
                  Applications and Environments
                </Text>
              </Row>
            </Table.td>
          </Table.tr>
        </Table.tbody>
      </When>
      {filteredApps.map((application) => (
        <AppEnvRow
          key={application?.nid}
          name={application.name}
          nid={application?.nid}
          environments={application?.environments ?? []}
          selectedEnvs={selectedEnvs}
          setSelectedEnvs={setSelectedEnvs}
          selectedApps={selectedApps}
          setSelectedApps={setSelectedApps}
          selectionType={selectionType}
          disabled={disabled}
        />
      ))}
    </Table>
  );
}
